import React from 'react';

// Railway環境用のダミーErrorBoundary - 実際には使用されない
const ErrorBoundary = ({ children }) => {
  return children;
};

export default ErrorBoundary;
